/**
 * Longueurs CSS ↔ px — le couple de conversion des box partagées entre le
 * document et le site (README webviewer §4 : « px affichés, rem stockés »).
 *
 * Vit ici parce que les deux éditeurs en ont besoin : l'inspecteur du document
 * comme les champs Puck saisissent des px et stockent du rem.
 * `webviewer/utils/proposalUnits.js` les réexporte pour ses appelants
 * historiques.
 */

/**
 * Longueur CSS (rem/px/nombre) → px, pour affichage éditeur.
 * @returns {number|null} null si vide ou format non géré (%, em…)
 */
export function cssLengthToPx(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  const str = String(value).trim();
  const remMatch = str.match(/^(-?\d*\.?\d+)rem$/);
  if (remMatch) return Math.round(Number(remMatch[1]) * 16);
  const pxMatch = str.match(/^(-?\d*\.?\d+)px$/);
  if (pxMatch) return Math.round(Number(pxMatch[1]));
  if (/^-?\d*\.?\d+$/.test(str)) return Math.round(Number(str));
  return null;
}

/** px (saisie éditeur) → longueur CSS rem stockée (3 décimales max). */
export function pxToRemCss(px) {
  if (px == null || px === '') return '';
  const n = Number(px);
  if (!Number.isFinite(n)) return '';
  if (n === 0) return '0rem';
  return `${Math.round((n / 16) * 1000) / 1000}rem`;
}
